import { userApi } from 'api/userApi';
import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store';
import { getSelectedSiteInfo } from '../store/siteInfoSlice';
import { getUser } from '../store/userSlice';

interface UserUpdatedEvent {
  avatar: string | null;
  first_name: string;
  last_name: string;
  name: string;
  username: string;
}

export function useRealtimeUserData() {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(getUser);

  const siteInfo = useAppSelector(getSelectedSiteInfo);

  const handleUserDataUpdated = useCallback(
    (_: UserUpdatedEvent) => {
      const workspace_id = siteInfo?.workspace_id as number;
      // Update the cache with the new user data
      dispatch(
        userApi.util.invalidateTags([
          { type: 'User', id: workspace_id },
        ])
      );

    },
    [dispatch, siteInfo]
  );

  // Listen to user data channel for user updated events using raw Echo API
  useEffect(() => {
    if (!currentUser?.id || !window.Echo) return;

    const channelName = `users.${currentUser.id}`;
    const privateChannel = window.Echo.private(channelName);

    privateChannel.listen('.UserUpdated', handleUserDataUpdated);

    // Cleanup function
    return () => {
      privateChannel.stopListening('.UserUpdated');
      window.Echo.leaveChannel(channelName);
    };
  }, [currentUser?.id, handleUserDataUpdated]);
}
